// src/emailUtils.js
const BLOCKED_DOMAINS = [
  'tempmail.com','10minutemail.com','guerrillamail.com',
  'mailinator.com','yopmail.com','dispostable.com','trashmail.com'
];

export function isDisposableEmail(email) {
  try {
    const domain = String(email).split('@')[1]?.toLowerCase() || '';
    return BLOCKED_DOMAINS.includes(domain);
  } catch {
    return true;
  }
}
